export type Difficulty = 'easy' | 'medium' | 'hard';

export type PhraseCategory = 'words' | 'idioms' | 'pop_culture' | 'sayings';

export interface PhraseItem {
  id: string;
  phrase: string;
  category: PhraseCategory;
  difficulty: Difficulty;
}

export type VoiceId =
  | 'asteria'
  | 'athena'
  | 'helios'
  | 'zeus'
  | 'orion'
  | 'arcas'
  | 'perseus'
  | 'angus'
  | 'orpheus'
  | 'luna'
  | 'hera'
  | 'stella'
  | 'aura-1';

export interface VoiceOption {
  id: VoiceId;
  name: string;
  gender: 'Female' | 'Male' | 'Neutral';
  accent?: string;
}

export const DEEPGRAM_VOICES: VoiceOption[] = [
  { id: 'asteria', name: 'Asteria', gender: 'Female', accent: 'US' },
  { id: 'athena', name: 'Athena', gender: 'Female', accent: 'US' },
  { id: 'luna', name: 'Luna', gender: 'Female', accent: 'US' },
  { id: 'hera', name: 'Hera', gender: 'Female', accent: 'US' },
  { id: 'stella', name: 'Stella', gender: 'Female', accent: 'US' },
  { id: 'zeus', name: 'Zeus', gender: 'Male', accent: 'US' },
  { id: 'helios', name: 'Helios', gender: 'Male', accent: 'US' },
  { id: 'orion', name: 'Orion', gender: 'Male', accent: 'US' },
  { id: 'arcas', name: 'Arcas', gender: 'Male', accent: 'US' },
  { id: 'perseus', name: 'Perseus', gender: 'Male', accent: 'US' },
  { id: 'angus', name: 'Angus', gender: 'Male', accent: 'UK' },
  { id: 'orpheus', name: 'Orpheus', gender: 'Male', accent: 'US' },
  { id: 'aura-1', name: 'Aura 1 (Default)', gender: 'Neutral', accent: 'Expressive' },
];

export type GameStatus = 'idle' | 'loading_audio' | 'playing' | 'won' | 'revealed';

export interface GameStats {
  solved: number;
  streak: number;
  bestStreak: number;
  hintsUsed: number;
  replaysCount: number;
}

export interface CloudflareConfig {
  accountId: string;
  apiToken: string;
}
